module.exports = {"color1":"rgb(200, 28, 46)","color2":"rgb(49, 49, 49)","color3":"rgb(78, 78, 78)","baseBoxShadow":"rgba(0, 0, 0, 0.4) 3px 3px 10px 0px"};